export const styles = () => ({
  root: {
    maxWidth: 500
  },
  select: {
    margin: 0,
  },
});